<template>
  <b-table striped :items="notifications" :fields="['Policy', 'Risk Score', 'Status']">
    <template #cell(Policy)="data">
      <h4>
        <router-link :to="data.item._link.replace('#', '/')">{{ data.value | policy('address', (data.item.Reference || data.item._link_id || '').replace('|', ', ')) }}</router-link>
      </h4>
      <div>{{ data.value | policy('policy') }}</div>
    </template>
  </b-table>
</template>

<script>
export default {
  props: ['notifications']
}
</script>
